"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inbox = void 0;
class Inbox {
    constructor(props) {
        this.content = props?.content || null;
        this.date = props?.date || null;
        this.image = props?.image || null;
        this.read = false;
        this.sender = "ÜMA";
        this.timestamps = props?.timestamps || null;
        this.title = props?.title || null;
        this.type = "messages";
    }
}
exports.Inbox = Inbox;
